import { getRevenueAnalytics } from './http/labRevenueAnalytics';
import type { GetRevenueAnalyticsOptions } from './http/labRevenueAnalytics';
import type { QueryObserverOptions } from '@tanstack/query-core';
import type { RevenueAnalyticsRawRow } from 'src/admin/LAB/RevenueAnalytics/types';

/** QueryKey constant for revenue analytics. */
export const LAB_REVENUE_ANALYTICS = 'lab-revenue-analytics';

/**
 * Query for one page of per-symbol revenue analytics. With no
 * `providerId` it loads the aggregate across all providers; with one it
 * narrows to that provider.
 *
 * `providerId`, `symbol`, `skip`, and `limit` are all part of the key so
 * distinct provider / page / search slices don't clobber each other, and
 * they can be invalidated together via the `[LAB_REVENUE_ANALYTICS,
 * providerId]` prefix. Toggling superuser needs no key dimension:
 * QueryCacheUserService resets user-scoped queries when the effective
 * identity changes. Callers own the `enabled` gate (the scope must be
 * known before the query runs).
 */
export const getRevenueAnalyticsQuery = (
    options: GetRevenueAnalyticsOptions = {},
): QueryObserverOptions<RevenueAnalyticsRawRow[], Error, RevenueAnalyticsRawRow[]> => {
    const { providerId, skip, limit, symbol } = options;
    return {
        queryKey: [LAB_REVENUE_ANALYTICS, providerId || null, symbol ?? null, skip ?? null, limit ?? null],
        queryFn: () => getRevenueAnalytics(options),
    };
};
